var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGearSixBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 25H10C4.5 25 0 20.5 0 15V10C0 4.5 4.5 0 10 0H15C20.5 0 25 4.5 25 10V15C25 20.5 20.5 25 15 25Z",
    fill: "#75DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.8C14.3 15.8 15.8 14.3 15.8 12.5C15.8 10.7 14.3 9.19995 12.5 9.19995C10.7 9.19995 9.19995 10.7 9.19995 12.5C9.19995 14.3 10.7 15.8 12.5 15.8Z",
    stroke: "white",
    strokeMiterlimit: 3.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 9.30005C17.5 9.50005 17.6 9.80005 17.7 10L19.5 11C19.7 12 19.7 13 19.5 14L17.7 15C17.6 15.3 17.4 15.5 17.3 15.7V17.7C16.5 18.4 15.7 18.9 14.7 19.2L12.9 18.2C12.6 18.2 12.3 18.2 12 18.2L10.3 19.2C9.29998 18.9 8.39998 18.4 7.69998 17.7V15.7C7.49998 15.5 7.39998 15.2 7.29998 15L5.49998 14C5.29998 13 5.29998 12 5.49998 11L7.29998 10C7.39998 9.70005 7.59998 9.50005 7.69998 9.30005V7.30005C8.49998 6.60005 9.29998 6.10005 10.3 5.80005L12.1 6.80005C12.4 6.80005 12.7 6.80005 13 6.80005L14.7 5.80005C15.7 6.10005 16.6 6.60005 17.3 7.30005V9.30005Z",
    stroke: "white",
    strokeMiterlimit: 3.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSixBackground);
export default __webpack_public_path__ + "static/media/GearSixBackground.a3a4ad7f98224c3cfe6fff903580ac29.svg";
export { ForwardRef as ReactComponent };